import { render, staticRenderFns } from "./shareToWX.vue?vue&type=template&id=1bc6b548&scoped=true&"
import script from "./shareToWX.vue?vue&type=script&lang=js&"
export * from "./shareToWX.vue?vue&type=script&lang=js&"
import style0 from "./shareToWX.vue?vue&type=style&index=0&id=1bc6b548&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc6b548",
  null
  
)

export default component.exports